<template>
  <div>
    <van-list
  v-model="loading"
  :finished="finished"
  finished-text="没有更多了"
  @load="onLoad"
>
<van-cell v-for="item in list" :key="item.id" style="background: #f9f9f9;">
                    <div   class="induction-list-item">
                        <header>
                            <div class="l">
                                <span >状态</span>
                            </div>
                            <div class="r">{{ item.statusName }}</div>
                        </header>
                        <center>
                            <main >
                                <p><span>申请类型:</span>{{ item.type }}</p>
                                <p><span>申请时间：</span>{{ item.createTime }} </p>
                                <p><span>申请原因：</span> {{ item.reason }}</p>
                            </main>
                        </center>
                        <footer>
                            <div style="display: flex;justify-content: space-around;">
                                <van-button size="" type="info" round style="width: 80%; margin-bottom: 20px;" @click="searchFileList(item)">
                                    查看证明
                                </van-button>
                               
                            </div>
                          </footer>
                    </div>
                </van-cell>
</van-list>
           
    </div>
    
</template>
<script>
import { empCertificateApplyListPage } from '@/api/empSystem/user'
import { Notify } from "vant";
export default {
  data() {
    return {
        pageNum: 0,
            pageSize: 5,
            list:[],
            finished:false,
            showBackTop: false,
            loading: false,
    };
  },
  methods:{
        goNav(destination) {
            this.$router.push({ path: destination });
        },
        searchFileList(item){
          this.$router.push({
                name: 'certificationFileView',
                query: { data: JSON.stringify(item) }
            });
        },
        getData(){
            const params = {
                pageNum :this.pageNum,
                pageSize:this.pageSize
            }
            empCertificateApplyListPage(params)
            .then(result => {
                this.loading = false;  
                
                if (result.data.code !== 200) {
                    Notify(result.data.message);
                    return;
                }

                const { data, total } = result.data.data;

                if (data.length < this.pageSize) {
                    this.finished = true;
                }

                this.list.push(...data);

                if (this.list.length >= total) {
                    this.finished = true;
                }
            })
            .catch(() => {
                this.loading = false;
                Notify('请求失败，请稍后重试');
            });

        },
        //数组去重
        uniqueFunc(arr) {
            const obj = {};
            arr = arr.reduce((total, next) => {
                obj[next.id] ? "" : (obj[next.id] = true && total.push(next));
                return total;
            }, []);
            return arr;
        },
        onLoad() {
            this.loading = true;
            this.pageNum++;
            this.getData();
           
        },
        
        
    },
    
};

</script>
<style lang="scss" scoped>
.induction-list-item {
    
  margin: 10px;
  // height: 607px;
  margin-top: 46px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 18px 0px rgba(0, 0, 0, 0.07);
  border-radius: 30px;
  

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 30px 40px;
    height: 106px;
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #3484fa;
    border-bottom: 1px solid #f2f2f2;
    .l {
      display: flex;
      align-items: center;
      span {
        margin-left: 21px;
      }
      .van-image {
        width: 44px;
        height: 44px;
      }
    }
  }
  center {
    box-sizing: content-box;
    padding: 0px 38px 50px 38px;
    text-align: left;
    position: relative;
    .wage {
      position: absolute;
      right: 38px;
      text-align: right;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
    }
    p {
      font-size: 28px;
      margin: 20px 0px;
      span {
        color: #999999;
      }
    }
    footer {
      // height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;

      .van-button {
        margin: 15px;
        width: 230px;
        height: 60px;
      }

      .van-button:nth-child(1) {
        width: 300px;
      }
    }
  }
}
</style>